import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  OnInit,
} from '@angular/core';
import { DragScrollType } from '@app/models/client/drag-scroll.type';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-b2b-drag-scroll-item',
  templateUrl: './b2b-drag-scroll-item.component.html',
  styleUrls: ['./b2b-drag-scroll-item.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass],
})
export class B2bDragScrollItemComponent implements OnInit {
  @Input({ required: true }) config: DragScrollType;

  constructor() {}

  @HostBinding('style.maxWidth') get getWidth() {
    if (this.config?.slidesPerView) {
      return Number(100 / Number(this.config?.slidesPerView)) + '%';
    }
    return '100%';
  }

  ngOnInit() {}
}
